import React from 'react';
import { Routes, Route } from 'react-router-dom';
import BlogMain from './BlogMain';
import BlogPost from './BlogPost';

const Blog = () => {
  return (
    <Routes>
      <Route path="/" element={<BlogMain />} />
      <Route path=":slug" element={<BlogPost />} />
    </Routes>
  );
};

export default Blog;
